import { Controller } from '@hotwired/stimulus';

import {
  getDocumentUserState,
  updateProgressFromResponse,
} from '../utils/case_experience_in_rails';

export default class extends Controller {
  static values = {
    documentId: Number,
    userId: Number,
  };

  async updateProgressUI() {
    const response = await getDocumentUserState(this.documentIdValue, this.userIdValue);

    if (response) {
      updateProgressFromResponse(response);
    }
  }

  connect() {
    this.updateProgressUI();
  }
}
